export type SSOLoginNames =
    | 'facebook-auth'
    | 'google-auth'
    | 'google-onetap-auth';

type SSOLoginSuccessTypes = {
    name: SSOLoginNames;
};

export const formatNewRelicSuccessData = ({ name }: SSOLoginSuccessTypes) => {
    return [name, { success: true }];
};
